import { baseUrlUser } from "../../../../constants/url.constant";
import { Utils } from "../../../common/views/Utils";
import { OrderModel } from "../../../orders/models/OrderModel";
import { OrderUtils } from "../../../orders/views/shared/OrderUtils";
import { ProductUtils } from "../../../products/views/ProductUtils";

type InvoicePrintItemProps = {
    order: OrderModel;
    onOrderDetail?: (order: OrderModel) => void;
}

export default function InvoicePrintItemView({ order, onOrderDetail }: InvoicePrintItemProps) {
    let url = order.product ? ProductUtils.getImageUrl(baseUrlUser, order.product.picture) : "";

    const width3 = Utils.getColumnWidth(3);
    const width9 = Utils.getColumnWidth(9);

    const priceHeader1 = () => {
        return <div className="ms-Grid-row gray pt-10">
            <div className={width3 + " left"}>Price</div>
            <div className={width3 + " right"}>Qty</div>
            <div className={width3 + " right"}>Rate</div>
            <div className={width3 + " right"}>Amount</div>
        </div>
    }

    const priceHeader2 = () => {
        return <div className="ms-Grid-row gray pt-10">
            <div className={width3 + " left"}>Price</div>
            <div className={width3 + " right"}>Rate</div>
            <div className={width3 + " right"}>Ship in US</div>
            <div className={width3 + " right"}>Amount</div>
        </div>
    }

    const price1 = () => {
        return <div className="ms-Grid-row pt-5">
            <div className={width3 + " left"}>${order.price.toFixed(2)}</div>
            <div className={width3 + " right"}>{order.qty}</div>
            <div className={width3 + " right"}>{order.rate}%</div>
            <div className={width3 + " right"}>${OrderUtils.getAmount(order).toFixed(2)}</div>
        </div>
    }

    const price2 = () => {
        return <div className="ms-Grid-row pt-5">
            <div className={width3 + " left"}>${order.price.toFixed(2)} (x{order.qty})</div>
            <div className={width3 + " right"}>{order.rate}%</div>
            <div className={width3 + " right"}>${order.domesticShipping.toFixed(2)}</div>
            <div className={width3 + " right"}>${OrderUtils.getAmount(order).toFixed(2)}</div>
        </div>
    }

    const onClick = () => {
        if (onOrderDetail) {
            onOrderDetail(order);
        }
    }

    return <div className={"ms-Grid-row pv-10" + (onOrderDetail ? " pointer" : "")} onClick={onClick}>
        <div className={width3 + " left"}>
            {OrderUtils.image(url, 0, 70, 0, false)}
        </div>
        <div className={width9}>
            <div>{OrderUtils.ProductInfo(order)}</div>

            {order.domesticShipping === 0 && <>
                {priceHeader1()}
                {price1()}
            </>}

            {order.domesticShipping !== 0 && <>
                {priceHeader2()}
                {price2()}
            </>}

            {!Utils.isNullOrEmpty(order.note) && <div className="firmed pt-10" style={{ fontSize: "x-small" }}>
                {order.note}
            </div>}
        </div>
    </div>
}